import React, { useEffect, useState } from "react";
import "./Blogs.css";
import { Link, useNavigate } from "react-router-dom";
import Hero from "../Components/Banner";
import banner from '../Assets/contact-bg.jpg'


const BlogList = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0); 
    fetch("https://blog.novaedubridge.com/api/get-blogs.php")
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched blogs:", data);
        setBlogs(data);
      })
      .catch((err) => console.error("Failed to fetch blogs:", err));
  }, []);

   const navigate = useNavigate();
  const handleServicesClick = () => {
     navigate('/Contact');
  };

  return (

    
    <div>
      
      <Hero
        title={<><span className="highlight">Our </span><br />Blogs</>}
        bgImage={banner}
         onButtonClick={handleServicesClick}
        buttonText="Contact Us"
      />
      <div className="blog-section container bodybg">
      <h1 className="blog-heading mt-5">Latest Blogs</h1>

      <div className="grid-container">
        {blogs.map((blog) => (
          <div key={blog.id} className="blog-card">
            <img
              src={blog.image_path}
  alt={blog.title}
            />
            <p className="blog-date">
              Published on:{" "}
              {new Date(blog.published_date).toLocaleDateString("en-IN", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
            <h2>{blog.title}</h2>
            <p>
              {blog.content.length > 80
                ? blog.content.slice(0, 80) + "..."
                : blog.content}
            </p>
            <Link className="read-more" to={`/blog-details?id=${blog.id}`}>
              Read More
            </Link>
          </div>
        ))}
      </div>
     
    </div>
    </div>
    
  );
};

export default BlogList;
